<template>
  <div class="animated fadeIn">
    <basic-heading title="New Laboratory" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>
    <permission-alert-gate :permissions="'add laboratory'">
      <template #gated-content>
        <laboratory-form @submit="submit" />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import Vue from "vue";
import VueNotifications from "vue-notifications";
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import LaboratoryForm from "@/components/lab/laboratory/LaboratoryForm";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import { notificationOptions } from "@/shared/toast-notification-options";
import { laboratoryNotifications } from "@/shared/notifications";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";

const LaboratoryRepository = LabRepositoryFactory.get("laboratory");

Vue.use(VueNotifications, notificationOptions);

export default {
  name: "LaboratoryAdd",
  components: {
    BasicHeading,
    HeaderButtonGroup,
    LaboratoryForm,
    PermissionAlertGate,
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-list",
            linkto: "/laboratory",
            title: "Laboratory list",
          },
        ],
      };
    },
  },
  methods: {
    async submit(payload) {
      try {
        const { data } = await LaboratoryRepository.create(payload);

        this.addSuccess();
        this.$router.push(`/laboratory/${data.id}`);
      } catch ({ response }) {
        this.addFail();
      }
    },
  },
  notifications: laboratoryNotifications,
};
</script>
